export default {
	properties: [
		{
			text: 'Dia de la semana',
			key: 'day_of_week',
			type: 'text',
			description: 'Ingrese el numero correspondiente al dia de la semana (Lunes = 1, Martes = 2, etc)',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Dia de entrega',
	plural_model_name_spanish: 'Dia de entrega',
	create_model_name_spanish: 'Nuevo Dia de entrega',
	text_delete: 'el',
}